export default function () {
  return {
    allPlans: [],
    loading: false,

    chosenCode: null,
    customerToken: null,
  };
}
